@if (design === '2026') {
  <!-- 2026 design: Follow is primary; Following is secondary and previews "Unfollow" on hover, but only
       once the pointer has left after following (like the community Subscribe button). Both labels share
       one grid cell, so the width never jumps. -->
  <button type="button" class="ut-btn follow" [class.ut-btn--secondary]="isFollowing" [class.ut-btn--sm]="size === 'sm'"
    [class.is-on]="isFollowing" [class.hover-locked]="hoverLocked()" [attr.aria-label]="ariaLabel"
    (mouseleave)="hoverLocked.set(false)" (click)="followClick($event)">
    <span class="follow__slot">
      @if (isFollowing) {
        <span class="follow__rest"><span class="material-icons" aria-hidden="true">check</span>Following</span>
        <span class="follow__hover"><span class="material-icons" aria-hidden="true">person_add_disabled</span>Unfollow</span>
      } @else {
        <span class="follow__rest"><span class="material-icons" aria-hidden="true">person_add</span>Follow</span>
      }
    </span>
  </button>
} @else {
  <div class="community-follow-btn long">
    <input
      type="checkbox"
      [id]="followCheckboxId"
      [(ngModel)]="isFollowing"
      (ngModelChange)="toggleFollow()"
    >
    <label
      [for]="followCheckboxId"
      class="checkbox-toggle noselect center"
      (click)="followClick($event)"
      (keydown)="followKeydown($event)"
      [attr.aria-label]="ariaLabel"
      role="button"
      tabindex="0"
      [attr.aria-pressed]="isFollowing"
    >
    </label>
  </div>
}
